<template>
    <div>
        <v-cookie></v-cookie>
        <div class="place">
            <span>位置：</span>
            <ul class="placeul">
                <li><a href="#">首页</a></li>
                <li><a href="#">账户设置</a></li>
                <li><a href="#">充值抵用券</a></li>
            </ul>
        </div>

        <div class="formbody">
            <div class="formtitle"><span>充值抵用券</span></div>
            <ul class="seachform mt20">
                <li>
                    <label style="width:100px;">状态</label>
                    <div class="vocation">
                        <el-select v-model="status" placeholder="请选择">
                            <el-option
                                v-for="item in statusOptions"
                                :key="item.value"
                                :label="item.text"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                </li>
                <li>
                    <label>&nbsp;</label>
                    <input type="button" class="scbtn" value="查询" @click="pageChange(1)"/>
                </li>
            </ul>
            <table class="tablelist">
                <thead>
                    <tr>
                        <th>说明</th>
                        <th>状态</th>
                        <th>到期时间</th>
                        <th>使用时间</th>
                        <th>来源</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, iddex) in list">
                        <td>{{item.description}}</td>
                        <td>
                            <template v-if="item.status == 0">
                                未使用
                            </template>
                            <template v-else-if="item.status == -1">
                                已过期
                            </template>
                            <template v-else-if="item.status == 2">
                                使用中，充值未完成
                            </template>
                            <template v-else-if="item.status == 1">
                                已使用
                            </template>
                        </td>
                        <td>{{item.endTime}}</td>
                        <td>
                            <template v-if="item.usedTime == undefined">
                                    
                            </template>
                            <template v-else>
                                {{ item.usedTime}}
                            </template>
                        </td>
                        <td>
                            <template v-if="item.type == 1">
                                充值赠送
                            </template>
                            <template v-else-if="item.type == 2">
                                新用户注册赠送
                            </template>
                            <template v-else-if="item.type == 3">
                                新用户充值送给推荐人
                            </template>
                            <template v-else-if="item.type == 4">
                                老用户赠送
                            </template>
                            <template v-else-if="item.type == 5">
                                活动赠送
                            </template>
                        </td>
                    </tr>
                    <tr v-if="list.length == 0">
                        <td colspan="6" style="text-align: center;">
                            您好，没有找到符合条件的记录！
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="pagin">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="pageIndex"
                    :page-sizes="[pageSize]"
                    :page-size="50"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalCount">
                </el-pagination>
            </div>

            <!-- 查询等待 -->
            <div style="position: fixed; width:100%; height:100%; z-index:9999; background:rgb(51, 51, 51); opacity: 0.3; 
                top: 0; left: 0;display: block;" v-show="loadingShow"></div>
            <div style="position:fixed; left: 50%; top:50%; transform: translate3d(-50%, -50%, 0px); -ms-transform: translate3d(-50%, -50%, 0px);
                -webkit-transform: translate3d(-50%, -50%, 0px); z-index: 10000;" v-show="loadingShow">
                <i class="el-icon-loading" style="font-size: 40px;color:coral;"></i>
                <div style="margin-left:-20px;color:coral;"><span style="font-size: 13px;">查询中,请稍后...</span></div>
            </div>

        </div>
    </div>
</template>
<script>
import cookie from '@/components/cookie.vue'
export default {
    data() {
        return {
            status: '0',
            statusOptions: [
                {text: '未使用', value: '0'},
                {text: '已过期', value: '-1'},
                {text: '已使用', value: '1'},
                {text: '使用中，充值未完成', value: '2'},
            ],
            list: [],
            pageIndex: 1,
            pageSize: 50,
            totalCount: 0,
            loadingShow: true,
        }
    },
    components : {
        'v-cookie' : cookie,
    },
    mounted() {
        this.pageChange(1)
    },
    methods: {
        handleSizeChange(val) {
            this.pageChange(val)
        },
        handleCurrentChange(val) {
            this.pageChange(val)
        },
        pageChange(pageIndex) {
            this.loadingShow = true;
            var that = this
            let param = {'status': this.status, 'pageIndex': pageIndex, 'pageSize': this.pageSize}
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + "/person/usercoupon.json",
                data: param,
                headers: {
                    'Content-Type': 'application/json;charset=UTF-8',
                    'token': this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    that.list = res.data.usercouponList;
                    that.pageIndex = res.data.page.pageIndex;
                    that.pageSize = res.data.page.pageSize;
                    that.totalCount = res.data.page.totalCount;
                    that.loadingShow = false;
                }
                else
                {
                    that.$alert(res.data.msg)
                    return false;
                }
            })
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/person/usercoupon.vue